<script>
    import ViewPhotoModal from "./ViewPhotoModal.svelte";
    import ViewVideoModal from "./ViewVideoModal.svelte";
    import LoadingIcon from "./LoadingIcon.svelte";
    import MissingData from "./MissingData.svelte";
    import CommentTruncater from "./CommentTruncater.svelte";
    import {onMount, afterUpdate, onDestroy} from "svelte";
    import {_} from '../lib/i18n';
    import {navigate} from "svelte-routing";
    import {Constans} from "../lib/Constants";

    export let params = {};
    export let date;
    let path = '';
    $: path = (params && params.path) ? params.path : '';

    let progress = 0;
    $: progress = analyze ? analyze.commentsProgress : 0;

    let feedsUpdateIsFinished = false;
    $: feedsUpdateIsFinished = analyze ? analyze.feedsUpdateIsFinished : false;
    let mounted = false;
    $: progress && mounted && initialLoad();

    const counterIncValue = 10;

    onMount(async () => {
        mounted = true;
        document.addEventListener('scroll', onScroll);
    });

    onDestroy(async () => {
        document.removeEventListener('scroll', onScroll);
    });

    function onScroll(event) {

    }

    let isLoading = false;
    async function initialLoad() {
        if (progress < 100 || isLoading || items.length > 0) return;

        isLoading = true;
        try {
            await loadMore();
            analyze.setResults('comments', response.data);
        } catch (err) {
            console.error(err);
        }
        isLoading = false;
    }

    export let analyze;

    let isTemporary;
    $: isTemporary = (analyze && analyze.temporary ? true : false);

    export let showRating = false;

    let items = [];
    $: analyze && (items = (analyze.result && analyze.result.comments)  ? analyze.result.comments : []);

    let ownerId;
    $: analyze && (ownerId = analyze.account ? Number(analyze.account.instagram_id) : null);


    let showCounter = params.identity.isEnabledFreeTrial() ? 5 : 10;
    let showShowMore = false;
    //$: items && (showShowMore = (items.length > showCounter));
    $: items && (showShowMore = (items.length === showCounter));

    let filteredItems = [];
    $: (items || showCounter) && filterItems();

    let isEnabledFreeTrial = false;
    $: isEnabledFreeTrial = params.identity.isEnabledFreeTrial();

    function gotoTariffs() {
        navigate(`${path}/dashboard/subscription`);
    }

    function filterItems() {
        filteredItems = [...items];
        filteredItems.sort((a, b) => {
            if ( Date.parse(a.taken_at) < Date.parse(b.taken_at) ) {
                return 1;
            }
            if ( Date.parse(a.taken_at) > Date.parse(b.taken_at) ) {
                return -1;
            }
            return 0;
        });
        filteredItems = filteredItems.splice(0, showCounter);
    }

    function showMore() {
        showCounter += 10;
        if (showCounter > (items.length)) {
            showCounter = (items.length);
            showShowMore = false;
        }
    }

    function onImageError(event) {
        event.target.src = '/spy20-lk/img/image-empty.svg';
    }

    function onAvatarError(event) {
        event.target.src = '/spy20-lk/icons/avatar-empty.svg';
    }


    let selectedMedia = {};

    let unBluredItems = [2, 4, 6];
    function selectMedia(item, index) {
        if (!unBluredItems.includes(index + 1) && isEnabledFreeTrial) {
            gotoTariffs();
            return;
        }
        selectedMedia = item;
    }

    let showPhotoModal = false;
    let showVideoModal = false;

    let isLoadingMore = false;
    async function loadMore() {
        if (items.length > 0 && params.identity.isEnabledFreeTrial()) {
            navigate(`${path}/dashboard/subscription`);
            return;
        }


        const lastScrollY = window.scrollY;
        const lastScrollX = window.scrollX;
        isLoadingMore = true;

        if (params.loadMoreComments instanceof Function) {
            try {
                const newItems = await params.loadMoreComments(analyze.id, counterIncValue, items.length);

                const table = {};
                const res = newItems.filter(({id}) =>(!table[id] && (table[id] = 1)));

                showCounter += counterIncValue;
                items = items.concat(res);
            } catch (err) {
                console.error(err);
                isLoadingMore = false;
            }
        }

        isLoadingMore = false;
        window.scrollTo(lastScrollX, lastScrollY);
    }




</script>

{#if !isTemporary}
    {#if items.length > 0}
        {#each items as item, index}
            <div class="feed-item feed-item_comment">
                <div class="feed-item__header">
                    {#if showRating}
                        <div class="feed-item__rating">{index + 1}</div>
                    {/if}
                    <div class="feed-item__header-wrapper">
                        <img src={item.account.photo} alt="" class="feed-item__avatar {(!unBluredItems.includes(index + 1) && isEnabledFreeTrial) ? 'blur-content' : ''}" on:error={onAvatarError} />
                        <div class="feed-item__info-wrapper">
                            {#if (!unBluredItems.includes(index + 1) && isEnabledFreeTrial)}
                                <p class="feed-item__name" on:click={gotoTariffs}>@{$_('commentsResult.someone')}</p>
                            {:else}
                                {#if Number(item.owner_id) === ownerId}
                                    <a href={`https://instagram.com/${item.username}`} class="feed-item__name" target="_blank">@{item.username}</a>
                                {:else}
                                    <a href={`https://instagram.com/${item.owner_name}`} class="feed-item__name" target="_blank">@{item.owner_name}</a>
                                {/if}
                            {/if}

                            <div class="feed-item__stats-wrapper">
                                {#if Number(item.owner_id) === ownerId}
                                    <div class="feed-item__stats-item">
                                        <div class="feed-item__stats-label">
                                            <div class="feed-item__stats-icon feed-item__stats-icon_give">
                                                <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M6.8285 6.82847L1.17165 1.17161M1.17165 1.17161L5.41429 1.17161M1.17165 1.17161L1.17165 5.41425" stroke="#57A41B" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            </div>
                                            <p class="feed-item__stats-title">{$_('commentsResult.fromTarget')}</p>
                                        </div>
                                    </div>
                                {:else}
                                    <div class="feed-item__stats-item">
                                        <div class="feed-item__stats-label">
                                            <div class="feed-item__stats-icon feed-item__stats-icon_get">
                                                <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M1.1715 1.17153L6.82835 6.82839M6.82835 6.82839L2.58571 6.82839M6.82835 6.82839L6.82835 2.58575" stroke="#1B62A4" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            </div>
                                            <p class="feed-item__stats-title">{$_('commentsResult.toTarget')}</p>
                                        </div>
                                    </div>
                                {/if}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="feed-item__body">
                    <div class="feed-item__content-wrapper">
                        <div class="feed-item-comment-content">
                            <div class="feed-item-comment-content__text-wrapper">
                                {#if (!unBluredItems.includes(index + 1) && isEnabledFreeTrial)}
                                    <p class="feed-item-comment-content__text">
                                        {$_('commentsResult.commentIsHidden')}
                                    </p>
                                    <div class="feed-item-comment-content__show-more" on:click={gotoTariffs}>
                                        {$_('commentsResult.unlockComment')}
                                    </div>
                                {:else}
                                    <CommentTruncater {item} length="100" />
                                {/if}
                            </div>
                            <div class="feed-item-comment-content__post-wrapper">
                                <div class={`feed-item-comment-content__flag feed-item-comment-content__flag_${Number(item.owner_id) === ownerId ? 'give' : 'get'}`}>
                                    {#if Number(item.owner_id) === ownerId}
                                        <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M6.8285 6.82847L1.17165 1.17161M1.17165 1.17161L5.41429 1.17161M1.17165 1.17161L1.17165 5.41425" stroke="#57A41B" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    {:else}
                                        <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1.1715 1.17153L6.82835 6.82839M6.82835 6.82839L2.58571 6.82839M6.82835 6.82839L6.82835 2.58575" stroke="#1B62A4" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    {/if}
                                </div>
                                <div class="feed-item-comment-content__img-wrapper">
                                    <img src={item.preview} alt=""
                                         class="feed-item-like-content__image {(!unBluredItems.includes(index + 1) && isEnabledFreeTrial) ? 'blur-content' : ''}"
                                         on:error={onImageError}
                                         on:click={() => {
                                                 selectMedia(item, index);
                                                 showPhotoModal = item.video ? false : true;
                                                 showVideoModal = item.video ? true : false;
                                         }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        {/each}

        {#if showShowMore}
            <button class="button button_ghost feed-content__load-more-btn" on:click={loadMore} disabled={isLoadingMore}>
                <LoadingIcon show={isLoadingMore} height="16" width="16" />
                {$_('commentsResult.loadMore')}
            </button>
        {/if}
    {:else}
        <MissingData {analyze} {path} analyzeInProgress={!feedsUpdateIsFinished} category="comments" />
    {/if}
{/if}

{#if selectedMedia}
    <ViewPhotoModal instagramLink={selectedMedia.media_link}
                    imageUrl={selectedMedia.preview}
                    imageCreatedAt={new Date(Date.parse(selectedMedia.taken_at))}
                    type={Constans.typeHeaders.COMMENT}
                    bind:show={showPhotoModal}
    />

    <ViewVideoModal instagramLink={selectedMedia.media_link}
                    videoUrl={selectedMedia.video}
                    videoCreatedAt={new Date(Date.parse(selectedMedia.taken_at))}
                    type={Constans.typeHeaders.COMMENT}
                    bind:show={showVideoModal}
    />
{/if}

<style>
    .feed-item__avatar {
        border-radius: 100%;
    }
    .feed-item-comment-content {
        justify-content: space-between;
    }
    .feed-item-like-content__image {
        max-width: 100%;
    }
    .blur-content {
        -webkit-filter: blur(10px);
        filter: blur(10px);
    }
</style>